import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { listLazyRoutes } from '@angular/compiler/src/aot/lazy_routes';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-Quarter-Filter',
  templateUrl: './Quarter-Filter.component.html',
  styleUrls: ['./Quarter-Filter.component.scss']
})
export class QuarterFilterComponent implements OnInit {
FromDate:string;
ToDate:string;
quarters: { Key?: string, Value?: string }[] = [];

QuarterConfig = {
  displayKey: "Key", //if objects array passed which key to be displayed defaults to description
  search: true, //true/false for the search functionlity defaults to false,
  placeholder: 'Select', // text to be displayed when no item is selected defaults to Select,
  noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
  searchPlaceholder: 'Search', // label thats displayed in search input,
  //searchOnKey: 'name' // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
  customComparator: (n1,n2)=>{
    if (n1.Value > n2.Value) {
      return 1;
  }

  if (n1.Value < n2.Value) {
      return -1;
  }

  return 0;
  } // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case
}

@Output() QuarterChange: EventEmitter<{fromDate?:string; toDate?:string;disableCalenders?:boolean}> = new EventEmitter<{fromDate?:string; toDate?:string; disableCalenders?:boolean}>();
//@Output() Uploaded: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private translate: TranslateService) { 
    this.setQuarterValues();
    this.setPaymentStatusConfigDDL();
  }

  ngOnInit() {
  }

  changeQuarter(quar: string) {
    let quarter = parseInt(quar);
    if (quarter) {
    
      let currentYear = (new Date()).getFullYear();
      switch (quarter) {
        case 1:
          this.FromDate = currentYear + "-01-01";
          this.ToDate = currentYear + "-03-31";
          this.QuarterChange.emit({fromDate : this.FromDate, toDate: this.ToDate,disableCalenders:true})
          break;
        case 2:
          this.FromDate = currentYear + "-04-01";
          this.ToDate = currentYear + "-06-30";
          this.QuarterChange.emit({fromDate : this.FromDate, toDate: this.ToDate,disableCalenders:true})
          break;
        case 3:
          this.FromDate = currentYear + "-07-01";
          this.ToDate = currentYear + "-09-30";
          this.QuarterChange.emit({fromDate : this.FromDate, toDate: this.ToDate,disableCalenders:true})
          break
        case 4:
          this.FromDate = currentYear + "-10-01";
          this.ToDate = currentYear + "-12-31";
          this.QuarterChange.emit({fromDate : this.FromDate, toDate: this.ToDate,disableCalenders:true})
          break;
      }
    } else {
      this.FromDate = "";
      this.ToDate = "";
      this.QuarterChange.emit({fromDate : this.FromDate, toDate: this.ToDate,disableCalenders:false})
    }
  }
  
  setQuarterValues(){
    this.translate.get("Quarter-container.Labels.Quarter1").subscribe(translatedValue => {
      this.quarters.push({ Key: translatedValue, Value: '1' });
    });
    this.translate.get("Quarter-container.Labels.Quarter2").subscribe(translatedValue => {
      this.quarters.push({ Key: translatedValue, Value: '2' });
    });
    this.translate.get("Quarter-container.Labels.Quarter3").subscribe(translatedValue => {
      this.quarters.push({ Key: translatedValue, Value: '3' });
    });
    this.translate.get("Quarter-container.Labels.Quarter4").subscribe(translatedValue => {
      this.quarters.push({ Key: translatedValue, Value: '4' });
    });
    this.quarters.sort(function(a, b){return parseInt(a.Value)-parseInt(b.Value)});  
  }

  setPaymentStatusConfigDDL() {
    this.translate.get("Common-container.Labels.Select").subscribe(translatedValue => {
      this.QuarterConfig.placeholder = translatedValue;
    });
    this.translate.get("Common-container.Labels.Noresultsfound").subscribe(translatedValue => {
      this.QuarterConfig.noResultsFound = translatedValue;
    });
    this.translate.get("Common-container.Labels.Search").subscribe(translatedValue => {
      this.QuarterConfig.searchPlaceholder = translatedValue;
    });
  }

}
